import { Injectable } from '@angular/core';
import { CentralService } from '../central.service';

@Injectable({
  providedIn: 'root'
})

export class OffersService extends CentralService {
  protected resource: string = "extensions";
}
